module.exports = __webpack_public_path__ + "static/img/apps.e9c48b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/apps.png
// module id = 0s6E
// module chunks = 52